import { createFeatureSelector } from '@ngrx/store';

import { upsellFeatureName, UpsellModuleState } from '@upsell/store/state/upsell-module.state';

export const upsellRootSelector = createFeatureSelector<UpsellModuleState>(upsellFeatureName);
